import { Img } from 'components/shared';
import * as React from 'react';
export default {
  Img,
  React
};